import { render, staticRenderFns } from "./KabMerauke.vue?vue&type=template&id=fb728e3e"
import script from "./KabMerauke.vue?vue&type=script&lang=js"
export * from "./KabMerauke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports